// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { messages, colorGradientContrastRatio, colorGradientAALevel, colorGradientAAALevel, colorGradientPass, colorGradientFail } from '../messages/main';
import { getContrastFromTwoRGBAs } from './utils/color-parser';
/**
 * @hidden
 */
var ColorContrastLabelsVue2 = {
  name: 'KendoColorContrastLabels',
  props: {
    bgColor: Object,
    rgba: Object
  },
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var ls = provideLocalizationService(this);
    var contrastRatioMessage = ls.toLanguageString(colorGradientContrastRatio, messages[colorGradientContrastRatio]);
    var AALevelMessage = ls.toLanguageString(colorGradientAALevel, messages[colorGradientAALevel]);
    var AAALevelMessage = ls.toLanguageString(colorGradientAAALevel, messages[colorGradientAAALevel]);
    var passMessage = ls.toLanguageString(colorGradientPass, messages[colorGradientPass]);
    var failMessage = ls.toLanguageString(colorGradientFail, messages[colorGradientFail]);
    var contrast = getContrastFromTwoRGBAs(this.$props.rgba, this.$props.bgColor);
    var requiredAAContrast = 4.5.toFixed(1);
    var requiredAAAContrast = 7.0.toFixed(1);
    var contrastText = "".concat(contrastRatioMessage, ": ").concat(contrast.toFixed(2));
    var aaText = "".concat(AALevelMessage, ": ").concat(requiredAAContrast);
    var aaaText = "".concat(AAALevelMessage, ": ").concat(requiredAAAContrast);
    var aaPass = contrast >= 4.5;
    var aaaPass = contrast >= 7;
    var success = h("span", {
      key: 1,
      "class": "k-contrast-validation k-text-success"
    }, [passMessage, " ", h("span", {
      "class": "k-icon k-i-check"
    })]);
    var error = h("span", {
      key: 2,
      "class": "k-contrast-validation k-text-error"
    }, [failMessage, " ", h("span", {
      "class": "k-icon k-i-close"
    })]);
    return h("div", {
      "class": "k-vbox k-colorgradient-color-contrast"
    }, [h("div", {
      "class": "k-contrast-ratio"
    }, [h("span", {
      "class": "k-contrast-ratio-text"
    }, [contrastText]), aaPass ? h("span", {
      "class": "k-contrast-validation k-text-success"
    }, [h("span", {
      "class": "k-icon k-i-check"
    }), aaaPass && h("span", {
      "class": "k-icon k-i-check"
    })]) : h("span", {
      "class": "k-contrast-validation k-text-error"
    }, [h("span", {
      "class": "k-icon k-i-close"
    })])]), h("div", [h("span", [aaText]), aaPass ? success : error]), h("div", [h("span", [aaaText]), aaaPass ? success : error])]);
  }
};
/**
 * @hidden
 */
var ColorContrastLabels = ColorContrastLabelsVue2;
export { ColorContrastLabels, ColorContrastLabelsVue2 };